<template>
  <div id="CallContent">
    <div v-if="callSection == 'card' || callSection =='points'">
      <div class="subtitle">
        <p>Scegli la carta</p>
        <p>che vuoi chiamare:</p>
      </div>
      <div class="row">
        <CallCell cardName="A" cardView="Asso" v-bind:disabled="isDisabled('A')" />
        <CallCell cardName="3" cardView="3" v-bind:disabled="isDisabled('3')" />
        <CallCell cardName="K" cardView="Re" v-bind:disabled="isDisabled('K')" />
      </div>
      <div class="row">
        <CallCell cardName="Q" :cardView="table.card_type == 'napoletane'? 'Cavallo' : 'Donna'" v-bind:disabled="isDisabled('Q')" />
        <CallCell cardName="J" cardView="Fante" v-bind:disabled="isDisabled('J')" />
        <CallCell cardName="7" cardView="7" v-bind:disabled="isDisabled('7')" />
      </div>
      <div class="row">
        <CallCell cardName="6" cardView="6" v-bind:disabled="isDisabled('6')" />
        <CallCell cardName="5" cardView="5" v-bind:disabled="isDisabled('5')" />
        <CallCell cardName="4" cardView="4" v-bind:disabled="isDisabled('4')" />
        <CallCell cardName="2" cardView="2" v-bind:disabled="isDisabled('2')" />
      </div>
      <div class="row" v-if="callSection == 'points'">
        <Counter />
      </div>
      <div class="row">
        <CallCell cardName="pass" cardView="Passo" v-bind:disabled="isDisabled('pass')" />
      </div>
    </div>
    <div v-else-if="callSection == 'suit'">
      <div class="subtitle">
        <p>Scegli la carta</p>
        <p>che vuoi chiamare:</p>
      </div>
      <div class="row">
        <SuitCell :cardName="calledCard + 'h'" v-bind:disabled="false" />
        <SuitCell :cardName="calledCard + 'd'" v-bind:disabled="false" />
      </div>
      <div class="row">
        <SuitCell :cardName="calledCard + 's'" v-bind:disabled="false" />
        <SuitCell :cardName="calledCard + 'c'" v-bind:disabled="false" />
      </div>
    </div>
  </div>
</template>

<script>
import CallCell from "@/components/CallCell";
import SuitCell from "@/components/SuitCell";
import Counter from "@/components/Counter";
import { mapGetters } from "vuex";

export default {
  name: "CallTable",
  components: {
    CallCell,
    Counter,
    SuitCell,
  },
  mounted() {
    window.Echo.channel("game-" + this.game.id).listen("CardCalledEvent", e => {
      this.$store.commit("call/updateCall", e);
      this.$store.commit("game/updateUserTurn", e.nextUser);
    });
    window.Echo.channel("game-" + this.game.id).listen("CallEndEvent", e => {
      this.$store.commit("call/updateCallSection", e);
    });
    window.Echo.channel("game-" + this.game.id).listen("CallWinnerEvent", e => {
      this.$store.commit("call/winningUpdate", e);
      this.$store.commit("game/updateUserTurn", e.nextPlayerId);
    });
  },
  computed: {
    ...mapGetters({
      callSection: "call/callSection",
      calledCard: "call/calledCard",
      game: "game/game",
      isMyTurn: "game/isMyTurn",
      winnerUser: "call/winnerUser",
      calledPoints: "call/calledPoints",
      table: "tables/tableActive"
    })
  },
  data() {
    return {
      cardTime: true,
      pointTime: true
    };
  },
  methods: {
    isDisabled(card) {
      let map = {
        A: 1,
        "3": 2,
        K: 3,
        Q: 4,
        J: 5,
        "7": 6,
        "6": 7,
        "5": 8,
        "4": 9,
        "2": 10,
        "pass": 11
      };
      return (!this.isMyTurn || map[card] <= map[this.calledCard]);
    }
  }
};
</script>
<style scoped>
#CallContent {
  background: rgba(128, 128, 128, 0.6);
  color: white;
  border: solid 3px black;
  border-radius: 25px;
  display: flex;
  z-index: 10;
}
.row {
  display: flex;
  justify-content: space-around;
}
.subtitle {
  margin: 1em;
  font-size: 20px;
  font-weight: 800;
}
@media all and (max-height: 860px), (max-width: 870px){
  .subtitle {
    margin: 0.5em;
    font-size: 18px;
    font-weight: 800;
  }
}
@media all and (max-height: 620px) {
  .subtitle {
    margin: 0.3em;
    font-size: 14px;
    font-weight: 800;
  }
}
</style>
